import { LOGO_MAX_BYTES } from '@UI/Pages/Administration/Organizations/Sidebars/LogoSidebar/FormData/constraint/logoConstraints';

/** A missing file is the required constraint's concern, not this one's. */
function isLogoFileSizeValid(value: File | null): boolean {
	return value === null || value.size <= LOGO_MAX_BYTES;
}

export default isLogoFileSizeValid;
